import DonationProgress from './DonationProgress';

export default DonationProgress;
